<template>
  <div>
    <div
      v-for="(page, pageIndex) in pageListWithDialogData"
      :key="pageIndex"
      class="page-container"
    >
      <div class="delete-container">
        <sc-button
          variant="danger"
          @click="handleOnDeleteFeatureIntroductionPage(pageIndex)"
          >ลบหน้านี้</sc-button
        >
      </div>
      <div class="image-uploader">
        <img
          :src="page.chooseImageDialogData.thumbnailUrl"
          class="image img-fluid mb-4"
        />
        <sc-button class="w-100" @click="handleOpenChooseImageDialog(pageIndex)"
          >อัพโหลดรูปภาพ</sc-button
        >
      </div>
      <div class="detail">
        <div class="label">หัวข้อ</div>
        <el-input
          v-model="page.title"
          class="input"
          type="textarea"
          autosize
          @input="handleOnTextInputChange('title', pageIndex, $event)"
        ></el-input>
        <div class="label">ข้อความ</div>
        <el-input
          v-model="page.message"
          :autosize="{ minRows: 3 }"
          class="input"
          type="textarea"
          @input="handleOnTextInputChange('message', pageIndex, $event)"
        ></el-input>
        <image-picker-modal
          v-bind="page.chooseImageDialogData"
          @cancel="handleCancelChooseImageDialog(pageIndex)"
          @confirm="handleConfirmChooseImageDialog(pageIndex, $event)"
        ></image-picker-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import ImagePickerModal from "@/lib/components/ImagePickerModal"

export default {
  components: {
    "el-input": Input,
    ScButton,
    ImagePickerModal,
  },
  props: {
    pageList: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      isShowModal: false,
      pageListWithDialogData: [],
    }
  },
  watch: {
    pageList() {
      this.setUpPageListWithDialogData()
    },
  },
  mounted() {
    this.setUpPageListWithDialogData()
  },
  methods: {
    handleOnTextInputChange(formName, pageIndex, $event) {
      const newValue = $event
      this.$emit("textInputChange", {
        formName,
        pageIndex,
        newValue,
        oldValue: this.pageList[pageIndex],
      })
    },
    handleOnDeleteFeatureIntroductionPage(pageIndexToDelete) {
      this.$emit("deletePage", pageIndexToDelete)
    },
    handleCancelChooseImageDialog(pageIndex) {
      this.pageListWithDialogData[pageIndex].chooseImageDialogData.isShow =
        false
    },
    handleConfirmChooseImageDialog(pageIndex, $event) {
      const imageFile = $event
      this.$emit("imageChange", {
        pageIndex,
        imageFile,
        oldValue: this.pageList[pageIndex],
      })
      this.isShowModal = false
    },
    handleOpenChooseImageDialog(pageIndex) {
      this.pageListWithDialogData[pageIndex].chooseImageDialogData.isShow = true
    },
    setUpPageListWithDialogData() {
      this.pageListWithDialogData = this.pageList.map((page) => ({
        ...page,
        chooseImageDialogData: {
          isShow: false,
          isLoading: false,
          canEdit: true,
          title: "เลือกรูป",
          width: 190,
          height: 330,
          recommendWidth: 375,
          recommendHeight: 665,
          thumbnailFile: page.imageFile,
          thumbnailUrl: page.imageFile
            ? URL.createObjectURL(page.imageFile)
            : "https://placehold.co/375x665",
        },
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 20px 0;
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 240px auto;
  grid-template-rows: 40px auto;
  .delete-container {
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    justify-content: flex-end;
  }
  .image-uploader {
    margin-right: 20px;
  }
}
.input {
  margin-bottom: 10px;
}
</style>
